module.exports = __webpack_public_path__ + "img/beimen_pano-min.2f14b1fb.jpg";